import { colors } from '@/styles/GlobalStyle';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1360px;

  margin-top: 50px;

  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    font-family: 'Exo 2';
    font-weight: 400;
    font-size: 48px;
    margin: 0;
    line-height: 52px;
  }

  @media (max-width: 850px) {
    margin-top: 25px;
  }
`;

export const Section = styled.section`
  width: 100%;
  max-width: 1160px;

  margin-top: 50px;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 360px));
  justify-content: center;

  gap: 23px;

  @media (max-width: 1240px) {
    padding: 0 40px;
  }

  @media (max-width: 499px) {
    padding: 0 16px;
  }

  @media (max-width: 850px) {
    margin-top: 25px;
  }
`;

export const Filial = styled.div`
  width: 100%;
  max-width: 360px;

  border-radius: 10px;

  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);

  padding-bottom: 25px;

  display: flex;
  flex-direction: column;

  img {
    object-fit: cover;
    height: 160px;
    position: relative;
  }

  div:not(.text):hover::after {
    content: 'Ver no mapa';
    background: rgba(0, 0, 0, 0.4);

    color: white;
    font-size: 16px;
    font-family: 'Sora';
    text-transform: uppercase;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;

    position: absolute;
    top: 0;

    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    z-index: 9;

    @keyframes fadeIn {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    animation: fadeIn 0.2s ease-in-out;
  }

  .text {
    margin-top: 10px;
    width: 100%;

    padding: 0 25px;

    display: grid;
    grid-template-rows: repeat(auto);

    flex: 1;

    > a.contact {
      width: fit-content;

      transition: 0.15s ease-in-out;

      :hover {
        color: ${colors.orange300};
      }
    }

    > a:not(.contact) {
      margin-top: 20px;

      color: ${colors.orange300};
      border-radius: 12px;
      width: 100%;

      text-transform: uppercase;

      font-size: 14px;
      line-height: 16px;
      font-weight: 700;
      font-family: 'Sora';
      letter-spacing: 1px;

      display: flex;
      justify-content: space-between;
      align-items: center;

      :hover {
        text-decoration: underline;
      }
    }
  }

  h2 {
    font-size: 24px;
    line-height: 18px;
    font-weight: 400;
    color: ${colors.orange500};
  }

  h3 {
    font-size: 12px;
    line-height: 18px;
    text-transform: uppercase;
    color: ${colors.gray700};
    margin-top: 6px;
    font-family: 'Sora';
  }

  .contact {
    display: flex;
    align-items: center;
    gap: 5px;
    color: ${colors.gray700};
    font-size: 15px;
    line-height: 18px;
    font-family: 'Sora';

    margin-top: 10px;
  }

  p {
    color: ${colors.gray700};
    font-size: 15px;
    line-height: 18px;
    font-family: 'Sora';

    margin-top: 10px;
  }
`;
